/**
 * config-router.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
// import {
//   Tab,
// } from '@mui/material';
import { /*Link,*/ Switch } from 'react-router-dom';
import Route from 'routing/route';
import Dogs from './dogs';
import Profile from './profile';
import Manage from './manage';
import ManagementRequest from './manage/management-request';
import Groups from './groups';
import GroupMemberRequest from './groups/group-member-request';
import BillingView from './billing/view';
import Recovery from './recovery';
import Vaccines from './vaccines';

// const configTabs = [
//   {
//     label: 'Profile',
//     component: 'a',
//     href: '/myaccount',
//     value: '/myaccount'
//   },
//   {
//     label: 'Dogs',
//     component: Link,
//     to: '/dogs',
//     value: '/dogs'
//   },
//   {
//     label: 'Billing',
//     component: 'a',
//     href: '/billing',
//     value: '/billing'
//   },
//   {
//     label: 'Groups',
//     component: 'a',
//     href: '/training/groups',
//     value: '/training/groups'
//   },
//   {
//     label: 'Custom Entries',
//     component: 'a',
//     href: '/custom-entries',
//     value: '/custom-entries'
//   },
// ];

// const CustomTab = withStyles(theme => ({
//   root: {
//     transition: '200ms ease-out',
//     '&:hover': {
//       color: theme.palette.primary.colors[1]
//     }
//   }
// }))(props => <Tab {...props} />);

const useStyles = makeStyles(theme => ({
  tabs: {
    borderBottom: `1px solid ${theme.palette.grey.colors[7]}`,
  },
  tabContent: {
    // marginTop: theme.spacing(6),
  }
}));

export default function ConfigPage(props) {
  const classes = useStyles();
  // const defaultTab = configTabs.find(configTab => configTab.value === window.location.pathname);
  // const [value, setValue] = React.useState(defaultTab ? defaultTab.value : false);

  // const changeTab = (event, newValue) => {
  //   setValue(newValue);
  // }

  return (
    <>
      {/* web tabs */}
      {/* <Hidden mdDown>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabs}
          onChange={changeTab}
          variant="fullWidth"
          aria-label="configuration items"
        >
          {configTabs.map(configTab => (<CustomTab key={configTab.value} {...configTab} />))}
        </Tabs>
      </Hidden> */}

      {/* mobile list */}
      {/* <Hidden lgUp>
        <List>
          {configTabs.map(configTab => (<ListItem key={configTab.value} {...configTab}>{configTab.label}</ListItem>))}
        </List>
      </Hidden> */}
      
      <div className={classes.tabContent}>
        <Switch> 

          {/* DOG ROUTES */}
          <Route key='/dogs' path={['/dogs']}><Dogs /></Route>
          <Route key='/:userId/dogs' path={['/:userId(\\d+)/dogs']}><Dogs /></Route>

          {/* PROFILE ROUTES */}
          <Route key='/profile' path="/profile"><Profile /></Route>
          <Route key='/:userId/profile' path={['/:userId(\\d+)/profile']}><Profile /></Route>

          {/* MANAGE ROUTES */}
          <Route key='/manage/request/:code' path={['/manage/request/:code']}><ManagementRequest /></Route>
          <Route key='/manage' path={['/manage']}><Manage /></Route>

          {/* BILLING ROUTES */}
          <Route key='/billing' path={['/billing']}><BillingView /></Route>
          <Route key='/:userId/billing' path={['/:userId(\\d+)/billing']}><BillingView /></Route>

          {/* GROUP ROUTES */}
          {/* TODO: continue supporting ./group route for a while - remove later */}
          <Route key='/group/invitation/:code' path={['/group/invitation/:code']}><GroupMemberRequest /></Route>
          <Route key='/groups/member-request/:code' path={['/groups/member-request/:code']}><GroupMemberRequest /></Route>
          <Route key='/groups' path={['/groups']}><Groups /></Route>

          {/* VACCINES ROUTES */}
          <Route key='/vaccines' path={['/vaccines']}><Vaccines /></Route>

          {/* RECOVERY */}
          <Route key='/recovery' path={['/recovery']}><Recovery /></Route>

        </Switch>
      </div>
    </>
  );
}
